import { React, useState } from "react"
import { useAuth0 } from "@auth0/auth0-react"

export const useJobDetails = () => {
  const [jobDetails, setJobDetails] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const { getAccessTokenSilently } = useAuth0()

  const fetchJobDetails = async (positionId) => {
    try {
      setLoading(true)
      const token = await getAccessTokenSilently({
        authorizationParams: {
          audience: process.env.REACT_APP_API_AUDIENCE,
        },
      })
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/Positions/${positionId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      if (response.ok) {
        const data = await response.json()
        setJobDetails(data)
      } else {
        throw new Error("Failed to fetch job details")
      }
    } catch (error) {
      setError(error.message)
    } finally {
      setLoading(false)
    }
  }

  return { jobDetails, loading, error, fetchJobDetails }
}

